import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function HeartIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path clipRule="evenodd" d="m12.5332 4.55738c2.0327-1.83646 5.1351-1.83657 7.1678 0l.1998.18926c2.2935 2.29362 2.0284 6.09006-.2912 8.35726-.0914.0892-.183.1793-.2742.2701-2.412 2.4-.8882.9006-3.4442 3.3006-1.4211 1.3344-2.6742 2.9641-3.3363 3.8789-.2464.34-.7626.3484-1.0166.014-.691-.9105-1.98257-2.5468-3.31525-3.8929l-.77403-.7793c-1.55349-1.5554-1.47652-1.4152-2.67597-2.5207-.12307-.1135-.2459-.2266-.36797-.3381-2.38088-2.1751-2.55791-5.92332-.27774-8.20373 2.07003-2.07 5.38607-2.13512 7.53396-.19453l.2039.19395.1916.1916.2766-.27715zm6.4131 1.14434c-1.5624-1.56235-4.0954-1.56229-5.6578 0l-1.2317 1.23105-1.1461-1.14609c-1.60958-1.60936-4.21933-1.60892-5.82886.00058-1.70785 1.70807-1.60898 4.56974.23378 6.25314.12344.1127.24813.2262.37266.341 1.35351 1.2475 1.08983.915 3.49395 3.3434 1.07237 1.0832 2.10767 2.3334 2.84827 3.2736.7295-.9524 1.7733-2.2158 2.9367-3.3082 2.5768-2.4195 1.0224-.8913 3.4154-3.2725.0944-.0938.1893-.1873.2836-.2795 1.8566-1.8146 1.971-4.74523.2801-6.43648z" fill={color} fillRule="evenodd" />
    </SVGWrapper>

  );
}

export default HeartIcon;
